import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_132: FaireProductEntity = {
  token: "legacy_prod_abbott-132",
  type: "product",
  name: "Blue & Ivory Printed Floor Rug",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/8b3dd9851cea2c8625bcc9b82e013626c5ded36bf0927bd41ea84fdc3d9ce3b5.jpeg",
  priceDollars: 89,
  subcategory: "Decorative Objects",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_home-accents"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
